import type { RouteRecordRaw } from 'vue-router'

import { ROUTE_DM } from '~/contexts/dm/router/routes'

export const DM_ROUTE_HOME_META = 'dm'
export const DM_ROUTE_URI_HOME_META = 'dm-timeline'
export const DM_ROUTE_URI_FACET_CONTENT_META = 'dm-filtered-{content_type}'
export const DM_ROUTE_URI_FACET_MEDIA_META = 'dm-filtered-media'
export const DM_ROUTE_URI_FACET_WEDO_META = 'dm-filtered-wedo'
export const DM_ROUTE_URI_MEMBERS_META = 'dm-members'

/** @example "/dm/" */
const DM_ROUTE_HOME: RouteRecordRaw = {
  name: ROUTE_DM.HOME,
  path: '',
  component: () => import('~/contexts/dm/pages/index.vue'),
  meta: {
    name: DM_ROUTE_HOME_META,
  },
}

/** @example "/dm/[id]" */
const DM_ROUTE_URI_HOME: RouteRecordRaw = {
  name: ROUTE_DM.URI_HOME,
  path: '',
  component: () => import('~/contexts/dm/pages/[thread_id]/index/index.vue'),
  meta: {
    name: DM_ROUTE_URI_HOME_META,
  },
}

/** @example "/dm/[id]/[post|survey]" */
const DM_ROUTE_URI_FACET_CONTENT: RouteRecordRaw = {
  name: ROUTE_DM.URI_FACETS_CONTENT,
  path: ':content_type',
  component: () => import('~/contexts/dm/pages/[thread_id]/index/[content_type].vue'),
  meta: {
    name: DM_ROUTE_URI_FACET_CONTENT_META,
  },
}

/** @example "/dm/[id]/media" */
const DM_ROUTE_URI_FACET_MEDIA: RouteRecordRaw = {
  name: ROUTE_DM.URI_FACETS_MEDIA,
  path: 'media',
  component: () => import('~/contexts/dm/pages/[thread_id]/index/media.vue'),
  meta: {
    name: DM_ROUTE_URI_FACET_MEDIA_META,
  },
}

/** @example "/dm/[id]/wedo" */
const DM_ROUTE_URI_FACET_WEDO: RouteRecordRaw = {
  name: ROUTE_DM.URI_FACETS_WEDO,
  path: 'wedo',
  component: () => import('~/contexts/dm/pages/[thread_id]/index/wedo.vue'),
  meta: {
    name: DM_ROUTE_URI_FACET_WEDO_META,
  },
}

/** @example "/dm/[id]/[post|idea|wiki|etc...]" */
const DM_ROUTE_URI_FACETS: RouteRecordRaw = {
  path: '',
  component: () => import('~/contexts/dm/pages/[thread_id]/index.vue'),
  children: [
    DM_ROUTE_URI_HOME,
    DM_ROUTE_URI_FACET_CONTENT,
    DM_ROUTE_URI_FACET_MEDIA,
    DM_ROUTE_URI_FACET_WEDO,
  ],
}

/** @example "/dm/[id]/members" */
const DM_ROUTE_URI_MEMBERS: RouteRecordRaw = {
  name: ROUTE_DM.URI_MEMBERS,
  path: 'members',
  component: () => import('~/contexts/dm/pages/[thread_id]/members.vue'),
  meta: {
    name: DM_ROUTE_URI_MEMBERS_META,
  },
}

/** @example "/dm/[id]/.*?" */
const DM_ROUTES_URI: RouteRecordRaw = {
  path: ':thread_id',
  children: [
    DM_ROUTE_URI_FACETS,
    DM_ROUTE_URI_MEMBERS,
  ],
}

/** Register all community routes as child of "/community" namespace */
export function getRoutes() {
  return [
    DM_ROUTE_HOME,
    DM_ROUTES_URI,
  ]
}
